<template>
  <div id="app">
    <web-form
      to-re-render
      :key="componentKey"
      @form-submitted="forceRerender"
    />
  </div>
</template>

<script>
import WebForm from "./components/WebForm.vue";

export default {
  name: "App",
  components: {
    WebForm
  },
  data: () => ({
    componentKey: 0
  }),
  methods: {
    /**
     * update component when form is submitted
     */
    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Roboto+Slab:400,700|Material+Icons");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
html,
body,
#app {
  font-family: "Roboto Condensed", sans-serif;
}

.md-layout-item {
  align-content: center;
  margin: 0 auto 0 auto;
}
</style>
